<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>

    <tt-divider ttRememberId="stocktransallocations_dividers">
        <tt-divider-columns>
            <tt-divider-pane ttSize="80">
                <tt-list-legacy [listItems]="itemsListAllocations" ltype="multi" typevar="g"></tt-list-legacy>
            </tt-divider-pane>

            <tt-divider-pane ttSize="20"></tt-divider-pane>
        </tt-divider-columns>
    </tt-divider>
</tt-page>
